<template>
  <div class="app-container">
      <!-- Desktop Restriction -->
      <div 
        v-if="!isMobile"
        class="restriction-container"
      >
        <div class="restriction-content">
          <div class="restriction-icon">📱</div>
          <h1>欢迎来到刘小刘资源站</h1>
          <p>为了给您带来最佳体验，本站仅支持手机浏览器访问</p>
        </div>
      </div>

      <!-- Mobile Content -->
      <div 
        v-if="isMobile"
        class="mobile-container"
      >
        <!-- Header -->
        <header class="header">
          <h1 class="title">刘小刘资源站</h1>
        </header>

        <!-- Main Content -->
        <main class="main-content">
          <!-- Watermark -->
          <Watermark />
          
          <!-- Resource List -->
          <ResourceList :resources="resources" />
        </main>
      </div>

      <!-- Toast -->
      <ToastMessage
        :visible="showToast"
        :message="toastMessage"
      />
  </div>
</template>

<script>
import './styles/main.css';
import { bilibiliApi } from './api/services';
import ResourceList from './components/ResourceList.vue';
import ToastMessage from './components/Toast.vue';
import Watermark from './components/Watermark.vue';

export default {
  name: 'App',
  components: {
    ResourceList,
    ToastMessage,
    Watermark
  },
  data() {
    return {
      resources: [],
      showToast: false,
      toastMessage: '',
      isMobile: false
    };
  },

  created() {
    this.checkDeviceType();
    window.addEventListener('resize', this.checkDeviceType);
    this.fetchResources();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkDeviceType);
  },
  methods: {
    fetchResources() {
      bilibiliApi.getResources()
        .then(data => {
          this.resources = data;
        })
        .catch(() => {
          this.showToastMessage('数据加载失败，请稍后重试');
        });
    },
    
    checkDeviceType() {
      const mobileThreshold = 768;
      this.isMobile = window.innerWidth < mobileThreshold || 
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },

    showToastMessage(message) {
      this.toastMessage = message;
      this.showToast = true;
      setTimeout(() => {
        this.showToast = false;
      }, 3000);
    }
  }
};
</script>